import { delay } from "redux-saga";
import { call, put, select, takeLatest } from "redux-saga/effects";

import { groups, policies,roles, users } from "../actions";
import { ADD_GLOBAL_ADMIN_START } from "../constants";
import selectors from "../selectors";
import { addGroupSaga, fetchGroupByNameSaga } from "./groups";
import { addPolicySaga } from "./policies";
import { fetchRoleByLabelSaga } from "./roles";
import { addUserSaga, fetchUserByUsernameSaga } from "./users";
import { REFRESH_DELAY } from "./utils";

/* sagas */

export function* addGlobalAdminSaga(action) {
  try {
    const { roleLabel, entityType, name } = action;
    let entityResult;

    if (entityType === "group") {
      const groupQueryResult = yield call(fetchGroupByNameSaga, name);
      if (groupQueryResult.length) {
        [entityResult] = groupQueryResult;
      } else {
        entityResult = yield call(addGroupSaga, name);
      }
    } else if (entityType === "user") {
      const userQueryResult = yield call(fetchUserByUsernameSaga, name);
      if (userQueryResult.length) {
        [entityResult] = userQueryResult;
      } else {
        entityResult = yield call(addUserSaga, name);
      }
    }

    // create RBAC global admin policy
    const rbacService = yield select(selectors.services.getRbac);
    const role = yield call(fetchRoleByLabelSaga, roleLabel);
    const globalAdminPolicy = {
      service: { $ref: rbacService.$uri },
      [entityType]: { $ref: entityResult.$uri },
      role: { $ref: role[0].$uri }
    };

    const errors = yield select(selectors.policies.hasErrors);
    if (!errors) {
      yield call(addPolicySaga, globalAdminPolicy);
      yield put(policies.addGlobalAdminSuccess());
      // Ensure server state has updated,
      // before refreshing.
      yield call(delay, REFRESH_DELAY);
      // refresh data
      yield put(groups.request());
      yield put(users.request());
      yield put(roles.request());
      yield put(policies.request());
    }
  } catch (error) {
    yield put(policies.addGlobalAdminFailed(error));
  }
}

/* watches */

export function* watchAddGlobalAdmin() {
  yield takeLatest(ADD_GLOBAL_ADMIN_START, addGlobalAdminSaga);
}
